import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminEntityService} from "./AdminEntityService";
import {ItemView, AwardItemRequest, ItemListResponse, HistoricPlayerItem} from "../../../generated/protocol";
import {injectable} from "inversify";

export const ITEM_HISTORY_SERVICE_NAME = "itemHistoryService";

export interface ItemHistoryService extends AdminEntityService<HistoricPlayerItem> {
}

@injectable()
export class ItemHistoryServiceImpl extends AbstractAdminEntityService<ItemView, ItemListResponse> {

    constructor() {
        super("/item/history");
    }
}



// WEBPACK FOOTER //
// ./src/app/service/admin/ItemHistoryService.ts